module.exports = __webpack_public_path__ + "static/pledge-7a3e3d193a4b1b0071decd14462caa1f.png";